import { useLocale } from "../../../hooks/useLocale";
import { msg } from "../../../locales/translate";
import Panel from "@ui/panel/Panel";
import Signal from "badmfck-signal";
import { useState } from "react";
import { VBox } from "@ui/box/Box";
import { RecursiveCSS } from "@ui/theme/GlobalTheme";
import { TButtonVariant } from "@ui/button/Button";
import { ClientInfoForm } from "src/view/pages/clientPage/subpages/ClientInfoForm";

export const S_CLIENT_REGISTER_POPUP = new Signal<{ clientID: number; onSuccess: () => void } | null>("S_CLIENT_REGISTER_POPUP");

// const mock = {
// 	client_information: {
// 		company: {
// 			company_name: "",
// 			trading_name: "",
// 			company_number: "",
// 			creation_date: "",
// 			tax_id_number: "",
// 		},

// 		registered_address: {
// 			street: "",
// 			city: "",
// 			country: "",
// 			zip: "",
// 		},

// 		physical_address: {
// 			same_as_registered: false,

// 			street: "",
// 			city: "",
// 			country: "",
// 			zip: "",

// 			$__street_linked: "same_as_registered",
// 			$__street_linked_value: false,

// 			$__city_linked: "same_as_registered",
// 			$__city_linked_value: false,

// 			$__country_linked: "same_as_registered",
// 			$__country_linked_value: false,

// 			$__zip_linked: "same_as_registered",
// 			$__zip_linked_value: false,
// 		},

// 		business_details: {
// 			business_description: "Select...",

// 			$__business_description_values: [
// 				{
// 					name: "Asset management services",
// 					value: "Asset management services",
// 				},
// 				{
// 					name: "Auctions",
// 					value: "Auctions",
// 				},
// 				{
// 					name: "Binary options",
// 					value: "Binary options",
// 				},
// 				{
// 					name: "Consulting services",
// 					value: "Consulting services",
// 				},
// 				{
// 					name: "Cryptocurrency exchange",
// 					value: "Cryptocurrency exchange",
// 				},
// 				{
// 					name: "Digital goods (including skins)",
// 					value: "Digital goods (including skins)",
// 				},
// 				{
// 					name: "Education services",
// 					value: "Education services",
// 				},
// 				{
// 					name: "Electronic money institution (EMI)",
// 					value: "Electronic money institution (EMI)",
// 				},
// 				{
// 					name: "File sharing/hosting services",
// 					value: "File sharing/hosting services",
// 				},
// 				{
// 					name: "Financial services",
// 					value: "Financial services",
// 				},
// 				{
// 					name: "Foreign exchange (FOREX)",
// 					value: "Foreign exchange (FOREX)",
// 				},
// 				{
// 					name: "Gambling and betting",
// 					value: "Gambling and betting",
// 				},
// 				{
// 					name: "Games of chance (roulette wheels, playing cards, spinning tops, dice, etc.)",
// 					value: "Games of chance (roulette wheels, playing cards, spinning tops, dice, etc.)",
// 				},
// 				{
// 					name: "Intermediation in trade",
// 					value: "Intermediation in trade",
// 				},
// 				{
// 					name: "Investment services",
// 					value: "Investment services",
// 				},
// 				{
// 					name: "Lending services",
// 					value: "Lending services",
// 				},
// 				{
// 					name: "Lottery marketing and advertising",
// 					value: "Lottery marketing and advertising",
// 				},
// 				{
// 					name: "Multimedia services (text, audio, images, animations, video and interactive content)",
// 					value: "Multimedia services (text, audio, images, animations, video and interactive content)",
// 				},
// 				{
// 					name: "Non-profit services (association, fund, charitable organization, etc.)",
// 					value: "Non-profit services (association, fund, charitable organization, etc.)",
// 				},
// 				{
// 					name: "Online gaming",
// 					value: "Online gaming",
// 				},
// 				{
// 					name: "Precious metal and stone services",
// 					value: "Precious metal and stone services",
// 				},
// 				{
// 					name: "Real estate",
// 					value: "Real estate",
// 				},
// 				{
// 					name: "Social networks",
// 					value: "Social networks",
// 				},
// 				{
// 					name: "Software/software provider",
// 					value: "Software/software provider",
// 				},
// 				{
// 					name: "Telecommunication and network",
// 					value: "Telecommunication and network",
// 				},
// 				{
// 					name: "Trade information technologies (IT)",
// 					value: "Trade information technologies (IT)",
// 				},
// 				{
// 					name: "Transportation and logistics",
// 					value: "Transportation and logistics",
// 				},
// 				{
// 					name: "Travel/leisure",
// 					value: "Travel/leisure",
// 				},
// 			],

// 			operations_duration: "Select...",
// 			$__operations_duration_values: [
// 				{
// 					name: "Less than a year",
// 					value: "Less than a year",
// 				},
// 				{
// 					name: "1-2 years",
// 					value: "1-2 years",
// 				},
// 				{
// 					name: "3-5 years",
// 					value: "3-5 years",
// 				},
// 				{
// 					name: "More than 5 years",
// 					value: "More than 5 years",
// 				},
// 			],
// 		},

// 		license: {
// 			number: "",
// 			authority: "",
// 			country: "",
// 		},

// 		contact: {
// 			name: "",
// 			phone: "",
// 			email: "",
// 		},
// 	},

// 	persons: [
// 		{
// 			role: {
// 				director: false,
// 				authorized_representative: false,
// 				ubo: false,
// 			},

// 			first_name: "",
// 			last_name: "",

// 			passport_number: "",
// 			date_of_birth: "",

// 			passport_issuing_country: "",
// 			passport_expiry_date: "",

// 			residence_address: "",
// 			city: "",
// 			country: "",
// 			zip: "",

// 			politicaly_exposed_person: false,
// 			us_person: false,

// 			holding_shares_percentage: "",

// 			sof: "Select...",
// 			$__sof_values: [
// 				{ name: "Reference letter from the bank", value: "Reference letter from the bank" },
// 				{
// 					name: "Salary proof document being a payment slip or tax statement",
// 					value: "Salary proof document being a payment slip or tax statement",
// 				},
// 				{ name: "Savings proving documents", value: "Savings proving documents" },
// 				{ name: "Investment proving documents", value: "Investment proving documents" },
// 				{ name: "Sale of assets proving documents", value: "Sale of assets proving documents" },
// 				{ name: "Sale of property proving documents", value: "Sale of property proving documents" },
// 				{
// 					name: "Confirmation (certificate) of movable or immovable property",
// 					value: "Confirmation (certificate) of movable or immovable property",
// 				},
// 				{ name: "Received loan (loan agreement)", value: "Received loan (loan agreement)" },
// 				{ name: "Inheritance proving documents", value: "Inheritance proving documents" },
// 			],
// 		},
// 	],

// 	transaction_information: {
// 		incoming: {
// 			expecting_monthly: 0,
// 			expecting_number: "Select...",
// 			$__expecting_number_values: [
// 				{ name: "&lt; 5 000", value: "&lt; 5 000" },
// 				{ name: "5 000 - 10 000", value: "5 000 - 10 000" },
// 				{ name: "10 000 - 25 000", value: "10 000 - 25 000" },
// 				{ name: "25 000 +", value: "25 000 +" },
// 			],
// 		},

// 		outgoing: {
// 			expecting_monthly: 0,
// 			expecting_number: "Select...",
// 			$__expecting_number_values: [
// 				{ name: "&lt; 5 000", value: "&lt; 5 000" },
// 				{ name: "5 000 - 10 000", value: "5 000 - 10 000" },
// 				{ name: "10 000 - 25 000", value: "10 000 - 25 000" },
// 				{ name: "25 000 +", value: "25 000 +" },
// 			],
// 		},
// 	},

// 	traffic_split: {
// 		region_distribution: {
// 			eu: 0,
// 			asia: 0,
// 			latin_america: 0,
// 			cis: 0,
// 			usa_canada: 0,
// 			other: 0,
// 		},

// 		top_countries: {
// 			country_1: "Select...",
// 			country_2: "Select...",
// 			country_3: "Select...",
// 			country_4: "Select...",
// 			country_5: "Select...",
// 		},
// 	},

// 	signature: {
// 		representative: {
// 			name: "",
// 			position: "",
// 			date: "",
// 		},

// 		information: false,
// 		products: false,
// 		authorised: false,
// 		liability: false,
// 		verify: false,
// 		scan: false,
// 		payment: false,
// 	},
// };

export const decoratorClientRegister = {
	form_intro: {},

	$__form_intro_decorator: {
		blockless: true,
		get title() { return msg("clientApplicationFormForEstablishingBusinessRelationship"); },
		get subtitle() { return msg("thisApplicationFormMustBeCompletedAndSubmittedByTheAuthorise_065da421"); },
	},

	client_information: {
		company: {
			get $__company_name_label() { return msg("registeredCompanyName"); },
			get $__trading_name_label() { return msg("dbaTradingCompanyName"); },
			get $__company_number_label() { return msg("registeredCompanyNumber"); },
			$__creation_date_type: "date",
			get $__creation_date_label() { return msg("dateOfCompanyRegistration"); },
			get $__tax_id_number_label() { return msg("taxIdNumber"); },
		},

		$__company_decorator: {
			blockless: true,

			blocks: [
				{
					blockless: true,
					gridTemplateColumns: "1fr",
					sx: { alignItems: "end" },
					order: ["company_name"],
				},
				{
					blockless: true,
					gridTemplateColumns: "1fr",
					sx: { alignItems: "end" },
					order: ["trading_name"],
				},
				{
					blockless: true,
					gridTemplateColumns: "1fr 1fr 1fr",
					sx: { alignItems: "end" },
					order: ["company_number", "creation_date", "tax_id_number"],
				},
			],
		},

		registered_address: {
			get $__street_label() { return msg("address"); },
			get $__city_label() { return msg("city"); },
			get $__country_label() { return msg("country"); },
			$__country_type: "country",
			get $__zip_label() { return msg("postalZipCode"); },
		},

		$__registered_address_decorator: {
			blockless: true,
			get title() { return msg("registeredCompanyAddress"); },
			gridTemplateColumns: "1fr 1fr",
		},

		physical_address: {
			$__same_as_registered_type: "boolean",
			get $__same_as_registered_label() { return msg("sameAsRegisteredAddress"); },
			get $__street_label() { return msg("address"); },
			get $__city_label() { return msg("city"); },
			get $__country_label() { return msg("country"); },
			$__country_type: "country",
			get $__zip_label() { return msg("postalZipCode"); },
		},

		$__physical_address_decorator: {
			blockless: true,
			get title() { return msg("physicalCompanyAddress"); },

			blocks: [
				{
					blockless: true,
					order: ["same_as_registered"],
				},
				{
					blockless: true,
					gridTemplateColumns: "1fr 1fr",
					sx: { alignItems: "end" },
					order: ["street", "city"],
				},
				{
					blockless: true,
					gridTemplateColumns: "1fr 1fr",
					sx: { alignItems: "end" },
					order: ["country", "zip"],
				},
			],
		},

		business_details: {
			$__business_description_type: "select",
			$__operations_duration_type: "select",
			get $__business_description_label() { return msg("businessDescription"); },
			get $__operations_duration_label() { return msg("durationOfOperation"); },
		},

		$__business_details_decorator: {
			blockless: true,
			get title() { return msg("businessDetails"); },
			gridTemplateColumns: "2fr 1fr",
		},

		license: {
			$__country_type: "country",
			get $__number_label() { return msg("licenceNumber"); },
			get $__authority_label() { return msg("licenceIssuingAuthority"); },
			get $__country_label() { return msg("countryOfLicenseIssuingAuthority"); },
		},

		$__license_decorator: {
			blockless: true,
			get title() { return msg("licenceInformationIfApplicable"); },
			gridTemplateColumns: "1fr 1fr 1fr",
		},

		contact: {
			get $__name_label() { return msg("name"); },
			get $__phone_label() { return msg("phoneNumber"); },
			get $__email_label() { return msg("email_969ccbd3"); },
		},

		$__contact_decorator: {
			blockless: true,
			get title() { return msg("contactDetails"); },
			gridTemplateColumns: "1fr 1fr 1fr",
		},
	},

	$__client_information_decorator: {
		get title() { return msg("text1ClientInformation"); },

		sx: { gap: "40px", paddingBottom: "30px" },
		blockless: true,

		blocks: [
			{
				blockless: true,
				order: ["company"],
			},
			{
				blockless: true,
				order: ["registered_address"],
			},
			{
				blockless: true,
				order: ["physical_address"],
			},
			{
				blockless: true,
				order: ["business_details"],
			},
			{
				blockless: true,
				order: ["license"],
			},
			{
				blockless: true,
				order: ["contact"],
			},
		],
	},

	persons: [
		{
			role: {
				$__director_type: "boolean",
				get $__director_label() { return msg("director"); },

				$__authorized_representative_type: "boolean",
				get $__authorized_representative_label() { return msg("authorizedRepresentative"); },

				$__ubo_type: "boolean",
				$__ubo_label: "UBO",
			},

			$__role_decorator: {
				blockless: true,
				gridTemplateColumns: "auto auto auto",
				sx: { gap: "20px" },
			},

			get $__city_label() { return msg("city"); },
			$__country_type: "country",
			get $__country_label() { return msg("country"); },
			get $__zip_label() { return msg("postalZipCode"); },

			get $__first_name_label() { return msg("firstName"); },
			get $__last_name_label() { return msg("lastName"); },
			get $__passport_number_label() { return msg("passportNumber"); },
			$__date_of_birth_type: "date",
			get $__date_of_birth_label() { return msg("dateOfBirth"); },
			$__passport_issuing_country_type: "country",
			get $__passport_issuing_country_label() { return msg("passportIssuingCountry"); },
			$__passport_expiry_date_type: "date",
			get $__passport_expiry_date_label() { return msg("passportExpiryDate"); },
			get $__residence_address_label() { return msg("residenceAddress"); },

			$__politicaly_exposed_person_type: "boolean",
			$__us_person_type: "boolean",

			get $__us_person_label() { return msg("usPerson"); },
			get $__politicaly_exposed_person_label() { return msg("politicallyExposedPerson"); },

			$__holding_shares_percentage_type: "%",
			get $__holding_shares_percentage_label() { return msg("holdingSharesInIfApplicableForUboOnly"); },

			get $__sof_label() { return msg("sofOrSowIfApplicableForUboOnly"); },
			$__sof_type: "select",
		},
	],

	$__persons_asblocks: true,
	get $__persons_itemtitle() { return msg("directorAuthorizedRepresentativeUbo"); },
	get $__persons_addbuttontitle() { return msg("addPerson"); },
	$__persons_decorator: {
		blockless: true,
		get title() { return msg("text2DirectorsAuthorizedRepresentativesAndUbosDetails"); },
		get subtitle() { return msg("inCaseOfAbsenceOfBeneCialOwnerSOwningOrControllingTheCustome_ff13894f"); },

		blocks: [
			{
				blockless: true,
				gridTemplateColumns: "1fr",
				order: ["role"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr 1fr",
				order: ["first_name", "last_name", "date_of_birth"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr 1fr",
				order: ["passport_number", "passport_issuing_country", "passport_expiry_date"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr",
				order: ["residence_address"],
			},

			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr 1fr",
				order: ["city", "country", "zip"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["us_person", "politicaly_exposed_person"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr",
				order: ["holding_shares_percentage"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr",
				order: ["sof"],
			},
		],
		sx: { gap: "10px" },
	},

	transaction_information: {
		incoming: {
			$__expecting_monthly_type: "EUR",
			get $__expecting_monthly_label() { return msg("expectedVolumeOfIncomingPaymentsPerMonth"); },

			$__expecting_number_type: "select",

			get $__expecting_number_label() { return msg("expectedNumberOfIncomingPaymentsTransactionsPerMonth"); },
		},

		$__incoming_decorator: {
			blockless: true,
			get title() { return msg("incomingPayments"); },
			gridTemplateColumns: "1fr 1fr",
			sx: { alignItems: "end" },
		},

		outgoing: {
			$__expecting_monthly_type: "EUR",
			get $__expecting_monthly_label() { return msg("expectedVolumeOfOutgoingPaymentsPerMonth"); },

			$__expecting_number_type: "select",

			get $__expecting_number_label() { return msg("expectedNumberOfOutgoingPaymentsTransactionsPerMonth"); },
		},

		$__outgoing_decorator: {
			blockless: true,
			get title() { return msg("outgoingPayments"); },
			gridTemplateColumns: "1fr 1fr",
			sx: { alignItems: "end" },
		},
	},

	$__transaction_information_decorator: {
		blockless: true,
		get title() { return msg("text3TransactionInformation"); },
		get subtitle() { return msg("provideInformationRegardingTheExpectedTransactionActivityOfTheCompany"); },

		blocks: [
			{
				blockless: true,
				gridTemplateColumns: "1fr",
				order: ["incoming"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr",
				order: ["outgoing"],
			},
		],
		sx: { gap: "20px", paddingBottom: "30px" },
	},

	traffic_split: {
		region_distribution: {
			$__eu_type: "%",
			get $__eu_label() { return msg("euCountries"); },

			$__asia_type: "%",
			get $__asia_label() { return msg("asia"); },

			$__latin_america_type: "%",
			get $__latin_america_label() { return msg("latinAmerica"); },

			$__cis_type: "%",
			get $__cis_label() { return msg("cisCountries"); },

			$__usa_canada_type: "%",
			get $__usa_canada_label() { return msg("usaCanada"); },

			$__other_type: "%",
			get $__other_label() { return msg("other"); },
		},

		$__region_distribution_decorator: {
			blockless: true,
			get title() { return msg("distributionOfClientsByRegion"); },
			gridTemplateColumns: "1fr 1fr 1fr",
			sx: { alignItems: "end" },
		},

		top_countries: {
			$__country_1_type: "country",
			get $__country_1_label() { return msg("country"); },

			$__country_2_type: "country",
			get $__country_2_label() { return msg("country"); },

			$__country_3_type: "country",
			get $__country_3_label() { return msg("country"); },

			$__country_4_type: "country",
			get $__country_4_label() { return msg("country"); },

			$__country_5_type: "country",
			get $__country_5_label() { return msg("country"); },
		},
		$__top_countries_decorator: {
			blockless: true,
			get title() { return msg("top5CountriesForTheHighestNumberOfTransactionsProcessed"); },
		},
	},

	$__traffic_split_decorator: {
		blockless: true,
		get title() { return msg("text4TrafficSplit"); },
		get subtitle() { return msg("provideInformationRegardingTheExpectedTransactionActivityOfTheCompany"); },

		blocks: [
			{
				blockless: true,
				gridTemplateColumns: "1fr",
				order: ["region_distribution"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr",
				order: ["top_countries"],
			},
		],
		sx: { gap: "20px" },
	},

	signature: {
		representative: {
			get $__name_label() { return msg("fullName"); },
			get $__position_label() { return msg("position"); },
			$__date_type: "date",
			get $__date_label() { return msg("date_99c40ab4"); },
		},
		$__representative_decorator: {
			blockless: true,
			get title() { return msg("authorizedCompanyRepresentative"); },
			gridTemplateColumns: "1fr 1fr 1fr",
		},

		$__information_type: "boolean",
		get $__information_label() { return msg("byAffixingMySignatureIHerebyCertifyThatTheInformationProvide_4385d29e"); },

		$__products_type: "boolean",
		get $__products_label() { return msg("byAffixingMySignatureIHerebyConfirmThatTheCompanyIsNotInvolv_8420f8cb"); },

		$__authorised_type: "boolean",
		get $__authorised_label() { return msg("byAffixingMySignatureIHerebyConfirmThatTheAboveAuthorisedPer_ecd8d49a"); },

		$__liability_type: "boolean",
		get $__liability_label() { return msg("byAXingMySignatureIHerebyConRmThatIAmAwareOfTheLiabilityIncl_e0a63d45"); },

		$__verify_type: "boolean",
		get $__verify_label() { return msg("byAffixingMySignatureIHerebyConfirmThatIAgreeThatImpayaHasTh_f7ef4b88"); },

		$__scan_type: "boolean",
		get $__scan_label() { return msg("byAffixingMySignatureIHerebyConfirmThatIAllowImpayaToScanThe_7c49b95b"); },

		$__payment_type: "boolean",
		get $__payment_label() { return msg("iUndertakeToInformThePaymentInstitutionOfAnyChangesToTheInfo_7ea7066f"); },
	},
	$__signature_decorator: {
		blockless: true,
		get title() { return msg("text4Signature"); },

		blocks: [
			{
				blockless: true,
				order: ["information"],
			},
			{
				blockless: true,
				order: ["products"],
			},
			{
				blockless: true,
				order: ["authorised"],
			},
			{
				blockless: true,
				order: ["liability"],
			},
			{
				blockless: true,
				order: ["verify"],
			},
			{
				blockless: true,
				order: ["scan"],
			},
			{
				blockless: true,
				order: ["payment"],
			},
			{
				blockless: true,
				order: ["representative"],
			},
		],
	},
};

//!TODO: component for any form?
export const ClientRegisterPopup = () => {
	useLocale();
	const requestData = S_CLIENT_REGISTER_POPUP.use();
	const [_busy, setBusy] = useState<boolean>(false);
	const [status, setStatus] = useState<"submitted" | "created" | "aml_review" | "rejected" | "board_review" | "active" | "blocked" | "deleted" | undefined>();
	const [state, setState] = useState<"small" | "full">("small");

	if (!requestData) return null;

	const closePopup = () => {
		setStatus(undefined);
		setBusy(false);
		S_CLIENT_REGISTER_POPUP.invoke(null);
	};

	const buttons: {
		title: string;
		onClick?: (data?: any) => void;
		sx?: RecursiveCSS;
		variant?: TButtonVariant;
	}[] = [
		{
			title: msg("comments"),
			variant: "secondarySmall",
			onClick: () => {
				if (state === "small") {
					setState("full");
				} else {
					setState("small");
				}
			},
		},
	];

	//!TODO: memo;
	if (status === "submitted") {
		buttons.push({
			title: msg("sendToReview"),

			onClick: async () => {
				//!TODO: type;

				setBusy(true);
				// const response = await GD.REQ_API.request({
				// 	method: "clients/group/review",
				// 	data: {
				// 		client_id: requestData.clientID,
				// 		group_id: requestData.merchantID,
				// 	},
				// });
				// if (response && response.data) {
				// 	requestData.onSuccess();
				// 	closePopup();
				// }
				setBusy(false);
			},
		});
	}

	const contentWidth = "750px";

	let sx: RecursiveCSS = {};
	if (state === "small") {
		sx = { maxWidth: contentWidth, minWidth: "420px", width: "99vw", minHeight: "90vh", maxHeight: "90vh" };
	} else {
		sx = { maxWidth: "1100px", minWidth: "420px", width: "99vw", minHeight: "90vh", maxHeight: "90vh" };
	}

	sx = {
		...sx,
		transition: "all .2s",
	};

	return (
		<Panel sx={sx} contentPadding="0px" decorator="absolute" label={msg("clientApplication")} onClose={closePopup}>
			{/* <HBox sx={{ height: "100%" }}> */}
			{/* <VBox sx={{ width: contentWidth, padding: "20px" }}> */}
			<VBox sx={{ backgroundColor: "#f8fafc", padding: "20px" }}>
				<ClientInfoForm clientID={requestData.clientID} />

				{/* <FormParser
						scrollable
						key="client_register"
						onSubmit={async (_data: any) => {
							// setBusy(true);
							// const response = await GD.REQ_API.request({
							// 	method: "clients/group/add",
							// 	data: data,
							// });
							// if (response && response.data && response.data.data) {
							// 	mergeObject(response.data.data, decorator);
							// }
							// setBusy(false);
							// return response;

							return new Promise(resolve => {
								setTimeout(() => {
									const res = JSON.parse(JSON.stringify(mock));
									mergeObject(res, decoratorClientRegister);
									resolve(res);
								}, 1000);
							});
						}}
						secondaryButton={null}
						buttons={buttons}
						onComplete={() => {
							requestData.onSuccess();
							closePopup();
						}}
						onRequest={async () => {
							// setBusy(true);
							// const response = await GD.REQ_API.request({
							// 	method: "clients/group/get",
							// 	data: {
							// 		client_id: requestData.clientID,
							// 		group_id: requestData.merchantID,
							// 	},
							// });
							// if (response && response.data && response.data.data) {
							// 	setStatus(response.data.status);
							// 	mergeObject(response.data.data, decorator);
							// }
							// setBusy(false);
							// return response;

							return new Promise(resolve => {
								setTimeout(() => {
									const res = JSON.parse(JSON.stringify(mock));
									mergeObject(res, decoratorClientRegister);
									resolve(res);
								}, 1000);
							});
						}}
					/> */}
			</VBox>

			{/* {state === "full" && <CommentsPanel sectionType={0} targetType="website_request" targetId={requestData.merchantID} />} */}
			{/* </HBox> */}
		</Panel>
	);
};
